module.exports = __webpack_public_path__ + "img/19_24.c4fa87fd.png";